// extracted by mini-css-extract-plugin
module.exports = {"actionBox":"ActionBox_actionBox__6fyzp","h1":"ActionBox_h1__1YJrg"};